
import ProjectManagement from "./project-management";

export default function ProjectsPage() {
  return <ProjectManagement />;
}
